// script 1 中为 view-script 压缩代码
// script 2 中为 sls
const script_src = [
  'https://s2.ssl.qhres2.com',
  'https://lf6-cdn-tos.bytecdntp.com',
  'https://s3.ssl.qhres2.com',
  'https://nami.cn-beijing.log.aliyuncs.com',
  'https://cdn.jsdelivr.net',
  'https://cdnjs.cloudflare.com/',
  'https://webapi.amap.com',
  'https://restapi.amap.com',
  'https://bot.n.cn',
  'https://vdata.amap.com',
  'https://vdata.amap.com',
  ...Array.from({ length: 10 }, (_, i) => {  
    const index = i < 10 ? `0${i}` : i;  
    return `https://vdata${index}.amap.com`;  
  }),
  'blob:',
].join(' ');

const style_src = [
  'https://s2.ssl.qhres2.com',
  'https://lf6-cdn-tos.bytecdntp.com',
  'https://s3.ssl.qhres2.com',
  'https://cdn.jsdelivr.net/',
  'https://cdnjs.cloudflare.com/',
].join(' ');

const connect_src = [
  'https://s2.ssl.qhres2.com',
  'https://lf6-cdn-tos.bytecdntp.com',
  'https://s3.ssl.qhres2.com',
  'https://nami.cn-beijing.log.aliyuncs.com',
  'https://cdn.jsdelivr.net/',
  'https://cdnjs.cloudflare.com/',
  'https://restapi.amap.com',
  'https://vdata.amap.com',
  ...Array.from({ length: 10 }, (_, i) => {  
    const index = i < 10 ? `0${i}` : i;  
    return `https://vdata${index}.amap.com`;  
  })
].join(' ');

const font_src = [
  'https://s2.ssl.qhres2.com',
  'https://lf6-cdn-tos.bytecdntp.com',
  'https://s3.ssl.qhres2.com',
  'https://nami.cn-beijing.log.aliyuncs.com',
].join(' ');

const HtmlViewTemplate = `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Sandbox Document</title>
      <meta http-equiv="Content-Security-Policy" content="default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval' ${script_src}; style-src 'self' 'unsafe-inline' ${style_src}; connect-src 'self' ${connect_src}; font-src 'self' ${font_src}; frame-src 'self'; img-src * data:; media-src *;">
      <base target="_blank" />
      <script name="script 1">
        window.alert=console.log,window.confirm=console.log,window.prompt=console.log,document.addEventListener("submit",function(e){e.preventDefault();var t=new FormData(e.target);handleFormSubmit(e.target.action,t)});var originalLocation=window.location,locationProxy=new Proxy(originalLocation,{set(e,t,n){return["href","assign","replace"].includes(t)?(handleNavigation(n.toString(),"location"),!0):Reflect.set(...arguments)}}),originalPushState=history.pushState;history.pushState=function(e,t,n){return handleNavigation(n,"history-push"),originalPushState.apply(history,arguments)};var originalReplaceState=history.replaceState;function handleLinkClick(e){console.log("拦截到超链接跳转1:",e)}function handleNavigation(e,t){console.log("拦截到导航请求 (来源:"+t+":"+e)}function handleFormSubmit(e,t){console.log("拦截到表单提交:",e,Object.fromEntries(t))}history.replaceState=function(e,t,n){return handleNavigation(n,"history-replace"),originalReplaceState.apply(history,arguments)},document.addEventListener("DOMContentLoaded",function(){new MutationObserver(function(e){e.forEach(function(e){e.addedNodes&&e.addedNodes.forEach(function(e){1===e.nodeType&&("A"===e.tagName&&e.addEventListener("click",handleLinkClick),"FORM"===e.tagName&&e.addEventListener("submit",handleFormSubmit))})})}).observe(document.body,{childList:!0,subtree:!0})});
      </script>
      <script name="script 2">
        var NamisoSLSLogger=function(){"use strict";var c=Object.defineProperty;var i=(s,t,e)=>t in s?c(s,t,{enumerable:!0,configurable:!0,writable:!0,value:e}):s[t]=e;var o=(s,t,e)=>i(s,typeof t!="symbol"?t+"":t,e);class s{constructor(){o(this,"baseData",{url:window.location.href,key:"so_fe",ua:navigator.userAgent,platform:"app",version:"10023"});o(this,"logstoreId","namiso");o(this,"supportUnHttp",!1)}log(a){(!this.baseData.url||!/^http/.test(this.baseData.url))&&!this.supportUnHttp||fetch(\`https://nami.cn-beijing.log.aliyuncs.com/logstores/\${this.logstoreId}/track?APIVersion=0.6.0\`,{headers:{accept:"*/*","accept-language":"zh-CN,zh;q=0.9,en;q=0.8,ja;q=0.7,mt;q=0.6","content-type":"text/plain;charset=UTF-8","sec-ch-ua":'"Not)A;Brand";v="99", "Google Chrome";v="127", "Chromium";v="127"',"sec-ch-ua-mobile":"?0","sec-ch-ua-platform":'"macOS"',"sec-fetch-dest":"empty","sec-fetch-mode":"no-cors","sec-fetch-site":"cross-site"},body:JSON.stringify({__logs__:[{...this.baseData,...a}],__tags__:{tags:"tags"},__topic__:"topic",__source__:"source"}),method:"POST",mode:"cors",credentials:"omit"})}setBaseData(a){this.baseData={...this.baseData,...a}}setData(a,r){this[a]=r}}const t=new s;return t.setData("logstoreId","namibot"),t.setData("supportUnHttp",!0),t}();

        try{
          NamisoSLSLogger.log({
            key : "html",
            action : "show",
            url : window.top.location.href,
          })
        } catch(e){}
      </script>
      <script name="script 3">
        document.addEventListener('click', function(evt){
          var href = evt.target.getAttribute('href') || ''
          if(href.startsWith('#')){
            evt.preventDefault();
          }
        })
      </script>
      <style>
        ::-webkit-scrollbar {
          display: block;
          width: 8px;
          height: 8px;
        }
        ::-webkit-scrollbar-thumb {
          border-radius: 100px;
          background: rgba(0, 0, 0, 0.06);
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #e6e6e6;
        }
        ::-webkit-scrollbar-track {
          border-radius: 100px;
        }
      </style>
    </head>
    <body>
      {html_content_holder}
    </body>
  </html>`;

export default HtmlViewTemplate;